import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import useAppModernisation from "../../hooks/useAppModernisation";
import useIsWebScreen from "../../hooks/useScreenSize";
import styles from "./calculator.module.scss";

const CalculatorResults = ({
  label = "Results",
  value,
  unit,
  showResult,
  expandableLabel = "Show calculation",
  expandedLabel = "Hide calculation",
  expandableContent,
  footnote,
  onExpand,
  defaultExpanded = true,
  isWebLayout = false,
}) => {
  const result = useAppModernisation();
  const { isAppMode } = result || { isAppMode: false }; 
  const { isDesktop } = useIsWebScreen();  
  
  const shouldShowExpandButton = isAppMode || (isWebLayout && !isDesktop);
  const initialExpanded = shouldShowExpandButton ? defaultExpanded : true;
  
  const [expanded, setExpanded] = useState(initialExpanded);
  const shouldShowResult = showResult && value != null;
  
  useEffect(() => {
    if (isWebLayout && isDesktop) {
      setExpanded(true); // Always expanded on desktop web
    }
  }, [isWebLayout, isDesktop]);

  if (!shouldShowResult) return null;

  const handleExpandClick = () => {
    setExpanded((prev) => {
      const next = !prev;
      if (next && typeof onExpand === "function") {
        setTimeout(() => onExpand(), 0);
      }
      return next;
    });
  };

  return (
    <div className={styles.resultsSection} data-testid="results-section">
      {label && <div className={styles.resultHeader}>{label}</div>}
      <div className={styles.resultValueRow}>
        {shouldShowResult && (
          <>
            <div className={styles.resultBox}>
              <span className={styles.resultValue}>{value}</span>
            </div>
            {unit && <span className={styles.resultUnit}>{unit}</span>}
          </>
        )}
      </div>
      {footnote && <div className={styles.resultNote}>{footnote}</div>}
      {expandableContent && shouldShowExpandButton && (
        <button
          type="button"
          className={styles.expandBtn}
          onClick={handleExpandClick}
        >
          {expanded ? expandedLabel : expandableLabel}
        </button>
      )}
      {expandableContent && expanded && (
        <div className={styles.expandContent}>{expandableContent}</div>
      )}
    </div>
  );
};

CalculatorResults.propTypes = {
  label: PropTypes.string,
  value: PropTypes.node,
  unit: PropTypes.node,
  showResult: PropTypes.bool,
  expandableLabel: PropTypes.string,
  expandedLabel: PropTypes.string,
  expandableContent: PropTypes.node,
  footnote: PropTypes.node,
  onExpand: PropTypes.func,
  defaultExpanded: PropTypes.bool,
  isWebLayout: PropTypes.bool,
};

export default CalculatorResults;
